import Vue, { CreateElement } from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import { Subtitle1 } from '@src/elements/typography/typography'
import { SwipeDots } from '@src/components/swipe-dots'

import './index.sass'

export class SwipeItemList {

  content: HTMLElement[]

  constructor (attributes?) {
    Object.assign(this, attributes)
  }
}

@Component
export class SwipeList extends Vue {

  @Prop({ required: true })
  private title: string

  @Prop({ required: true })
  private items: SwipeItemList[]

  private activeIndex: number = 0
  private translateX: number = 0
  private clientX: number
  private clientY: number
  private portraitMatch: any
  private lastDirection: string = ''

  addEventListeners () {
    const wrapper = document.getElementById(`list-wrapper-${this.title}`)
    if (wrapper) {
      wrapper.addEventListener('touchstart', this.getTouchStartCoordinates)
      wrapper.addEventListener('touchend', this.getTouchEndCoordinates)
    }
    this.portraitMatch.addEventListener('change', this.redrawComponent)
  }

  removeEventListeners () {
    const wrapper = document.getElementById(`list-wrapper-${this.title}`)
    if (wrapper) {
      wrapper.removeEventListener('touchstart', this.getTouchStartCoordinates)
      wrapper.removeEventListener('touchend', this.getTouchEndCoordinates)
    }
    this.portraitMatch.removeEventListener('change', this.redrawComponent)
  }

  mounted () {
    this.portraitMatch = window.matchMedia('(orientation: portrait)')
    this.addEventListeners()
  }

  beforeDestroy () {
    this.removeEventListeners()
  }

  getViewportsUnits () {
    const swipeItemWrapper = document.getElementById(`list-wrapper-${this.title}`)
    if (swipeItemWrapper) {
      const width = swipeItemWrapper.clientWidth
      const swipeItem = document.querySelector<HTMLElement>('.swipe-item')!
      const marginRightString = getComputedStyle(swipeItem).marginRight
      const marginRightNumber = Number(marginRightString!.split('px')[0])

      // vmin
      const viewportUnit = document.documentElement.clientWidth < document.documentElement.clientHeight ?
        document.documentElement.clientWidth : document.documentElement.clientHeight

      const widthInViewportUnit = width
        * (100 / viewportUnit)
      const marginInViewportUnit = marginRightNumber
        * (100 / viewportUnit)

      return { widthInViewportUnit, marginInViewportUnit }
    }

    return { widthInViewportUnit: null, marginInViewportUnit: null }
  }

  scrollHandler (direction) {
    const { widthInViewportUnit, marginInViewportUnit } = this.getViewportsUnits()
    if (widthInViewportUnit && marginInViewportUnit) {
      if (direction === 'forward') {
        if (this.activeIndex < Object.keys(this.items).length - 1) {
          this.activeIndex = this.activeIndex + 1
          this.translateX = this.translateX - widthInViewportUnit - marginInViewportUnit
        }
      } else if (this.activeIndex > 0) {
        this.activeIndex = this.activeIndex - 1
        this.translateX = this.translateX + widthInViewportUnit + marginInViewportUnit
      }
      this.lastDirection = direction
    }
  }

  getTouchStartCoordinates (e) {
    this.clientX = e.touches[0].clientX
    this.clientY = e.touches[0].clientY
  }

  getTouchEndCoordinates (e) {
    const deltaX = e.changedTouches[0].clientX - this.clientX
    const deltaY = e.changedTouches[0].clientY - this.clientY

    if ((deltaY >= -100) && (deltaY <= 100)) {
      if (deltaX < 0) {
        this.scrollHandler('forward')
      } else {
        this.scrollHandler('backward')
      }
    }
  }

  redrawComponent () {
    const { widthInViewportUnit, marginInViewportUnit } = this.getViewportsUnits()
    if (widthInViewportUnit && marginInViewportUnit) {
      if (this.lastDirection === 'forward') {

        this.translateX = -this.activeIndex * (widthInViewportUnit + marginInViewportUnit)

      } else if (this.lastDirection === 'backward') {
        this.translateX = -this.activeIndex * (widthInViewportUnit + marginInViewportUnit)
      }
    }
  }

  render (h: CreateElement) {
    return (
      <div
        class='swipe-list'>
        <Subtitle1>{this.title}</Subtitle1>
        <div
          id={`list-wrapper-${this.title}`}
          class='list-wrapper'
          onTouchStart={this.getTouchStartCoordinates}
          onTouchEnd={this.getTouchEndCoordinates}
          style={{ transform: `translate3d(${this.translateX}vmin, 0, 0)` }}
        >
          {this.items.map((swipeItemList) => (
            <div class='swipe-item'>
              {swipeItemList.content}
            </div>
          ))}
        </div>
        {this.items.length > 1 && <div class='dots-wrapper'>
          <SwipeDots
            count={this.items.length}
            activeIndex={this.activeIndex}
            />
        </div>}
      </div>
    )
  }
}
